import { render, staticRenderFns } from "./PdfFileViewer.vue?vue&type=template&id=bffbaffe&scoped=true&"
import script from "./PdfFileViewer.vue?vue&type=script&lang=js&"
export * from "./PdfFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfFileViewer.vue?vue&type=style&index=0&id=bffbaffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffbaffe",
  null
  
)

export default component.exports
import {QIcon,QTooltip,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip,QInnerLoading,QSpinnerGears}, component.options.components || {})
